@defer {
    <p-toast [preventDuplicates]="true" [preventOpenDuplicates]="true"/>
    <p-confirmDialog [style]="{width: '50vw'}">
        <ng-template pTemplate="header">
            <h3>Trámite Individual</h3>
        </ng-template>
    </p-confirmDialog>
    <app-skeleton [loading]="pageLoad"></app-skeleton>
    <div *ngIf="!pageLoad()&&!isPrjReady()" class="p-card grid align-items-center justify-content-center m-3">
        <div class="col-12 md:col-6 lg:col-6 py-5 px-6 border-none md:border-right-1 surface-border">
            <div class="flex align-items-center mb-1">
                <span class="text-5xl m-2">Mis Proyectos</span>
            </div>
            <div class="flex align-items-center mb-1">
                <div [routerLink]="'/users/proyectos/'" [queryParams]="{sessionId: sessionId}" class="cursor-pointer">
                    <div class="retract" style="">
                        <img class="color-image" [style]="{'width':'50%'}"
                             [src]="'/assets/demo/images/logos/iconos/construccion.png'">
                    </div>
                </div>
            </div>
            <div class="border-round overflow-hidden surface-200" style="height:.3rem">
                <div class="h-full" [ngClass]="'bg-yellow-500'" style="width:100%"></div>
            </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6 py-5 px-6 border-none md:border-right-1 surface-border">
            <div class="flex align-items-center mb-1">
                <span class="text-5xl m-2">Nuevo proyecto</span>
            </div>
            <div class="flex align-items-center mb-1">
                <div [routerLink]="'/users/proyectos/nuevo_proyecto/'" [queryParams]="{sessionId: sessionId}"
                     class="cursor-pointer">
                    <div class="retract">
                        <img class="color-image" [style]="{'width':'50%'}"
                             [src]="'/assets/demo/images/logos/iconos/casa.png'">
                    </div>
                </div>
            </div>
            <div class="border-round overflow-hidden surface-200" style="height:.3rem">
                <div class="h-full" [ngClass]="'bg-green-500'" style="width:100%"></div>
            </div>
        </div>
    </div>
    <p-card *ngIf="!pageLoad()&&isPrjReady()">
        <ng-template pTemplate="header">
            <div class="col-12 xl:col-12 p-0">
                <div class="m-3 mb-0 pt-3 h-full">
                    <app-generales-resumen *ngIf="this.tramite.selected()!" [timelineEvents]="[]"
                                           [goBackLabel]="'Mis proyectos'"
                                           [btnVerDetalles]="true"
                                           [selected]="this.tramite.selected()!"/>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="content" class="pt-0">
            <div>
                <p-tabMenu [style]="{'font-size':'1.4rem'}" [scrollable]="true" [model]="fases"
                           [activeItem]="faseActiva"></p-tabMenu>
            </div>
            <app-skeleton [loading]="tabLoad"></app-skeleton>
            <ng-container *ngIf="tramitesPorFase().length!=0; else noResultados">
                <div class="grid -mt-3 -ml-3 -mr-3">
                    <div class="col-12 md:col-6 lg:col-3 p-animate-fade"
                         *ngFor="let tramite of tramitesPorFase(), let i = index"
                         style="color: #303845;">
                        <div class="col-12">
                            <div
                                class="card p-0 overflow-hidden flex flex-column"
                                style="height: 175px;"
                                [style.backgroundColor]="tramite.tramiteEstado&&tramite.tramiteEstado.btnAgregarTramiteEnCarrito ? '#303845' : '#5F6775'">
                                <div class="flex align-items-center p-3">
                                    <i class="pi pi-tags text-2xl text-blue-500"></i>
                                    <div class="ml-3">
                                        <div class="font-medium text-md mb-3 flex-wrap"
                                             style="color:white; font-size:1.2rem; height: 5.1rem; overflow: auto;"
                                             [pTooltip]="tramite.nombreTramite" [tooltipPosition]="'top'">
                                            {{ tramite.nombreTramite }}
                                        </div>
                                        <p-scrollTop target="parent" styleClass="custom-scrolltop" [threshold]="100"/>
                                    </div>
                                </div>
                                <div class="flex justify-content-end mr-3">
                                    <div id="t-{{tramite.idTramite}}"
                                         class="flex sm:flex-row-reverse align-items-center sm:align-items-end gap-3 sm:gap-2">
                                        <button *ngIf="tramite.qtyglobal>=0"
                                                style="background-color: #3C4557"
                                                [loading]="loading()"
                                                (click)="getRequisitosTramitePorTipo(tramite.idTramite, tramite.nombreTramite)"
                                                pButton
                                                icon="pi pi-list-check" class="md:align-self-end mb-2 p-button-rounded"
                                                pTooltip="Consultar requisitos"></button>
                                        <button id="btn-{{i}}"
                                                style="background-color: #3C4557"
                                                *ngIf="tramite.tramiteEstado&&tramite.tramiteEstado?.btnAgregarTramiteEnCarrito"
                                                [disabled]="loading()!"
                                                [loading]="loading()"
                                                (click)="confirmAgregarTramite($event,tramite, i)"
                                                pButton
                                                icon="pi pi-plus" class="md:align-self-end mb-2 p-button-rounded"
                                                pTooltip="Agregar al carrito"></button>
                                    </div>
                                </div>
                                <img [src]="'assets/demo/images/logos/dot_logo.png'" class="-mt-8 ml-3 p-3"
                                     width="80px" alt="users" style="color: #303845; filter: invert(1) brightness(1.5);">
                            </div>
                            <p-tag *ngIf="tramite.tramiteEstado&&tramite.tramiteEstado.codigoEstado!=0"
                                   [style]="{ 'background':tramite.tramiteEstado.color}">
                                <div class="flex align-items-center gap-2">
                                    <i class="pi pi-tags text-xs"></i>
                                    <span class="text-base">{{ tramite.tramiteEstado.nombreEstado }}</span>

                                </div>
                            </p-tag>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #noResultados>
                <div class="grid m-5" *ngIf="!tabLoad()">
                    <p class="ml-3">
                        <span class="font-bold white-space-nowrap">
                            <h5>No hay trámites disponibles en esta fase</h5>
                        </span>
                    </p>
                </div>
            </ng-template>
            <p-sidebar [(visible)]="showRequisitos" styleClass="w-30rem" class="flex justify-content-start flex-wrap">
                <h4>REQUISITOS <b>{{ servicioRequisito }}</b></h4>
                <p-panelMenu [model]="requisitosPorTramiteMenu">
                    <ng-template pTemplate="item" let-item>
                        <a pRipple class="flex align-items-center px-3 py-2 cursor-pointer">
                            <i [class]="item.icon"></i>
                            <span class="ml-2">
                    {{ item.label }}
                </span>
                            <p-badge *ngIf="item.badge && item.badge=='Nuevo'" class="ml-auto" severity="info"
                                     [value]="item.badge"/>
                            <p-badge *ngIf="item.badge && item.badge=='Reforma'" class="ml-auto" severity="warning"
                                     [value]="item.badge"/>
                        </a>
                    </ng-template>
                </p-panelMenu>
                <p *ngIf="requisitosPorTramiteMenu.length==0">
                    <b>No cuenta con requisitos previos</b>
                </p>
            </p-sidebar>
        </ng-template>
    </p-card>
} @loading {
    <p-progressSpinner ariaLabel="loading"/>
}
